import React from "react";
import moment from "moment";

const CommonDatePicker = ({ value, onChange, minDate, disabled = false }) => {
  const formattedValue = value ? moment(value).format("YYYY-MM-DD") : "";

  return (
    <input
      type="date"
      value={formattedValue}
      disabled={disabled}
      onChange={(e) => {
        const val = e.target.value;
        onChange(val ? moment(val).toDate() : null);
      }}
      className="w-1/4 px-4 py-2 rounded-full border border-slate-200 bg-white text-slate-700 font-medium
                 focus:outline-none focus:ring-2 focus:ring-mpPurple transition-all
                 disabled:bg-slate-100 disabled:text-slate-400"
    />
  );
};

export default CommonDatePicker;
